import {
  Layout,
  LayoutCanvas,
  LayoutDefinition,
  LayoutObject,
} from '../../../types/types';
import { createLayoutRequestBody } from '../../../utils/layouts/createLayoutRequestBody';

type LayoutPutBodyParams = {
  isFixedMode: boolean;
  // Last loaded layout — the echoed keys come from it.
  layout: Layout | undefined;
  canvas: LayoutCanvas;
  objects: LayoutObject[];
  definition: LayoutDefinition;
};

// PUT body of the whole layout content. Canvas and objects go through the same
// body building as the dataset form submit (type defaults, '' → null, `saved`
// rules).
//
// Fixed layouts have no canvas in the PUT schema; the body is the full ordered
// object list. annotation/comment are echoed from the GET so the full-replace
// PUT keeps them. Free layouts send name + canvas + objects (annotation/comment
// stay omitted — the merge PUT keeps them untouched).
export const createLayoutPutBody = ({
  isFixedMode,
  layout,
  canvas,
  objects,
  definition,
}: LayoutPutBodyParams): Layout => {
  const bodyObjects = objects.map((object) =>
    createLayoutRequestBody(object, definition.objectForm, 'PUT')
  );

  if (isFixedMode) {
    return {
      name: layout?.name,
      ...(layout?.annotation !== undefined && {
        annotation: layout.annotation,
      }),
      ...(layout?.comment !== undefined && { comment: layout.comment }),
      objects: bodyObjects,
    };
  }

  return {
    name: layout?.name,
    canvas: createLayoutRequestBody(
      canvas as Record<string, unknown>,
      definition.canvasForm,
      'PUT'
    ) as LayoutCanvas,
    objects: bodyObjects,
  };
};
